
var iconLess = {};
import genaration from '../../utils/classname';
export var iconClass = genaration(iconLess, 'icon');